<div class="list-page">
  <div class="list-header">
    <h3>Shades</h3>
    <div class="list-actions">
    </div>
  </div>
  <app-list-container></app-list-container>
</div>
